import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MultiAutocomplete } from '../../../../MultiAutocomplete';
export function MultiSelectCell(param) {
    let { options, value, emptySearchText, placeholder, bi, onSelect, testId } = param;
    return /*#__PURE__*/ _jsx(MultiAutocomplete, {
        bi: bi,
        testId: testId,
        options: [
            ...options
        ],
        value: options.filter((option)=>value.includes(option.value)),
        getOptionId: (option)=>option.value,
        getOptionLabel: (option)=>option.label,
        getOptionDisabled: (option)=>option.disabled === true,
        noOptionsText: emptySearchText,
        placeholder: placeholder,
        chips: "wrap",
        onChange: (selected)=>onSelect(selected.map((option)=>option.value))
    });
}
